import { Component } from "../core/Component";
import GameConfig from "../core/data/GameConfig";
import { PlanckBodyComponent } from "./PlanckBodyComponent";
import { Player } from "./Player";
import { PlayerStateTypes } from "./PlayerStates/PlayerState";

export class FirecrackerEffect extends Component {

	obj: Player;
	body: PlanckBodyComponent;
	timer = 2;

	accel: number;
	minVY: number;
	boostX: number;

	allowSlam = false;

	constructor(obj: Player) {
		super(obj);
		this.body = this.obj.planckBody;
		this.timer = GameConfig.get<number>("firecrackerDuration");
		this.accel = GameConfig.get<number>("firecrackerAccelY");
		this.minVY = GameConfig.get<number>("firecrackerMaxVY");
		this.boostX = GameConfig.get<number>("firecrackerExplosionBoostX") * this.obj.detonatorMultiplier;
		this.obj.emit(PlayerStateTypes.Firecracker);
		if (this.body.velocity.y > 0) this.body.velocity.y = 0;
	}

	public update(dt: number): void {
		this.body.velocity.y -= this.accel * dt;
		if (this.body.velocity.y < this.minVY) this.body.velocity.y = this.minVY;
		this.timer -= dt;
		if (this.timer <= 0) {
			this.obj.endEffect();
			this.body.velocity.x = Math.max(this.boostX, this.body.velocity.x);
			this.scene.soundManager.play("collideTnt");
			this.obj.img.tint = this.obj.color;
			this.destroy();
		}
	}

}